<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title class="py-0 my-0" style="height: 80px">
        <div class="pl-2">
          <span class="grey--text title px-2" v-if="!reservation.name && authority.editGroupInfo">{{reservation.name}}</span>
          <span class="title px-2" v-else-if="reservation.name">{{reservation.name}}</span>
          <span class="title px-2" v-else>{{authority.name}}</span>
          <span class="grey--text">正在编辑</span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container class="pt-0" fluid grid-list-md>
          <v-layout v-if="authority.editGroupInfo" wrap>
            <v-flex sm6 xs12>
              <v-text-field
                label="预约名称"
                prepend-icon="$vuetify.icons.title"
                v-model="reservation.name"
                :disabled="status==='addVehicle'"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-textarea
                :rows="1"
                auto-grow
                label="预约描述"
                prepend-icon="$vuetify.icons.description"
                v-model="reservation.description"
                :disabled="status==='addVehicle'"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field prepend-icon="$vuetify.icons.comment" label="预约备注" v-model="reservationTips" :disabled="status==='addVehicle'"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout column v-if="type==='admin'">
            <v-switch
              :disabled="status==='addVehicle'"
              v-model="isSelf"
              label="开启自助预约"></v-switch>
            <v-layout v-if="isSelf">
              <v-flex xs6>
                <v-text-field label="自助预约总数" v-model="selfInfo.total" prepend-icon="$vuetify.icons.code"
                :rules="[$rules.requiredNum()]"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="每天预约数目" v-model="selfInfo.perDay" prepend-icon="$vuetify.icons.code"
                              :rules="[$rules.requiredNum()]"></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-card class="pl-3">
          <v-subheader>预约车辆
            <span class="error--text" style="font-size: 14px">*请勿预约出租车</span>
          </v-subheader>
          <v-layout class="mb-4" row wrap>
            <v-flex xs12>
              <l-data-table
                :headers="vehicleHeaders"
                :hide-headers="reservation.vehicles.length === 0"
                :init-pagination="{sortBy: 'id', descending: true}"
                :items="reservation.vehicles"
                auto-actions
                auto-title
                class=""
                flat
                hide-refresh
                no-data-text="没有车辆"
                selectable
                v-model="selected"
              ></l-data-table>
            </v-flex>
            <v-flex xs12>
              <!--<v-slide-y-transition  group>-->
              <div :key="'addForm'" v-show="isAddingVehicle">
                <v-container class="pa-0" grid-list-md>
                  <v-form ref="addVehicleForm">
                    <v-layout key="addInput" row wrap>
                      <v-flex sm6 xs12>
                        <l-plate-picker
                          :rules="[v => !reservation.vehicles.find(t => t.plate === v)|| '该车辆已存在']"
                          required
                          restrict
                          v-model="addVehicleForm.plate"
                        ></l-plate-picker>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          :rules="$rules.phone11()"
                          label="手机号码"
                          prepend-icon="$vuetify.icons.phone"
                          v-model="addVehicleForm.ownerTel"
                          validate-on-blur
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          label="车主姓名"
                          prepend-icon="$vuetify.icons.person"
                          v-model="addVehicleForm.ownerName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          label="所在单位"
                          prepend-icon="$vuetify.icons.org"
                          v-model="addVehicleForm.ownerOrg"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-select
                          :items="IDTypeItems"
                          :label="'证件类型'"
                          prepend-icon="$vuetify.icons.idCardType"
                          v-model="addVehicleForm.ownerIDType"
                        ></v-select>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          label="证件号码"
                          prepend-icon="$vuetify.icons.idCard"
                          v-model="addVehicleForm.ownerIDNumber"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn @click="addVehicle()" color="primary" flat>添加</v-btn>
                        <v-btn @click="addVehicle(0)" color="grey" flat>取消</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </div>
              <v-flex key="btnGroup" v-show="!isAddingVehicle">
                <v-btn
                  :disabled="reservation.vehicles.length >= authority.maxVehicleAmount"
                  @click="openAddVehicleForm"
                  class="mx-0"
                  color="primary"
                  flat
                >添加车辆
                </v-btn>
                <l-select-file
                  :dialog-props="vehicleFileProps"
                  :hint="'仅支持Excel(.xlsx)文件'"
                  :rules="vehicleFileRules"
                  @cancel="vehicleFileProps.activate = false"
                  @submit="readExcel"
                  file-type="excel"
                  select-type="dialog"
                  v-if="authority.maxVehicleAmount > 1"
                >
                  <v-btn class="mx-0" color="primary" flat
                         slot="activator">批量导入
                  </v-btn>
                  <template slot="before-drag">
                    <v-layout align-center class="mb-3 pl-2" row>
                      <span class="body-2">批量添加车辆需要上传特定格式的模板</span>
                      <v-btn
                        :href="templateHref"
                        @click="getVehicleFileTemplate"
                        color="primary"
                        flat
                        ref="templateBtn"
                        small
                        target="_blank"
                      >点此下载
                      </v-btn>
                    </v-layout>
                  </template>
                </l-select-file>
                <v-fade-transition>
                  <v-btn
                    @click="deleteVehicles(selected)"
                    class="mx-0"
                    color="error"
                    flat
                    v-if="selected.length > 0"
                  >删除选中车辆
                  </v-btn>
                </v-fade-transition>
              </v-flex>
              <!--</v-slide-y-transition>-->
            </v-flex>
          </v-layout>
          </v-card>
          <v-card class="pl-3">
          <v-subheader v-if="status!=='addVehicle'">通行规则</v-subheader>
          <v-layout class="mb-4" row wrap v-if="status!=='addVehicle'">
            <v-flex xs12>
              <l-pass-rule-list
                :pass-rules="reservation.rules"
                prefix-text="规则"
              >
                <template slot="action" slot-scope="{item, index}">
                  <div @click.stop>
                    <v-menu left>
                      <v-btn icon slot="activator" small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile
                          @click="openSetRuleDialog('edit',reservation.rules[index], index)">
                          <v-list-tile-title class="pr-1">
                            <v-icon class="pr-3" small>$vuetify.icons.edit</v-icon>
                            编辑
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="deleteRuleLocal(item, reservation.rules)">
                          <v-list-tile-title class="pr-1">
                            <v-icon class="pr-3" small>$vuetify.icons.delete</v-icon>
                            删除
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </l-pass-rule-list>
            </v-flex>
            <v-flex xs12>
              <v-btn
                :disabled="reservation.rules.length >= authority.maxRuleAmount"
                @click="openSetRuleDialog('new', null, reservation.rules.length)"
                class="mr-0 mx-1"
                color="primary" flat>添加规则
              </v-btn>
            </v-flex>
          </v-layout>
          </v-card>
          <v-card class="pl-3">
          <v-subheader v-if="authority.editPrompt&&status!=='addVehicle'" >通行提示</v-subheader>
          <v-layout class="mb-4" v-if="authority.editPrompt&&status!=='addVehicle'" wrap >
            <v-flex :class="opt.layout" :key="opt.key" v-for="opt in promptDefine">
              <v-textarea
                :prepend-icon="opt.icon"
                :rows="1"
                auto-grow=""
                v-bind="opt"
                v-model="reservation[opt.key]"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <person-info-card :person="reservation.owner" flat subheader="联系人" v-show="type!=='person'">
            <template slot="subheader-action">
              <v-btn
                @click="configDialog = {activate: true, item: {}, status: 'new', params: {}}"
                class="mx-0"
                color="primary"
                flat
                small
              >{{reservation.owner ? '变更受访人':'添加受访人'}}
              </v-btn>
            </template>
          </person-info-card>
          <person-info-card :person="reservation.applicant" flat subheader="申请人" v-show="type!=='person'"></person-info-card>
          </v-card>
        </v-container>
        <v-dialog max-width="500px" persistent scrollable v-model="configDialog.activate">
          <select-be-visit-dialog
            :params="configDialog.params"
            :raw-item="configDialog.item"
            :status="configDialog.status"
            :type="type"
            @cancel="configDialog.activate = false"
            @confirm="saveBeVisited"
            object-label="分组名称"
            v-if="configDialog.activate"
          ></select-be-visit-dialog>
        </v-dialog>
        <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
          <set-pass-rule-content
            :authority="authority"
            :params="{index: passRuleDialog.index, type: authority.name}"
            :rule="passRuleDialog.item"
            :status="passRuleDialog.status"
            :is-unit-reservation="authority.name === '单位预约'"
            @cancel="closeSetRuleDialog"
            @save="setPassRuleLocal($event, reservation.rules)"
            v-if="passRuleDialog.activate"
          ></set-pass-rule-content>
        </v-dialog>
        <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog.activate">
          <v-card>
            <v-card-title style="height: 64px;">
              <span class="title">导入车辆发生错误</span>
            </v-card-title>
            <v-card-text style="min-height: 350px; max-height: 500px">
              <div class="mb-4" v-if="importErrorDialog.fails.length > 0">
                <div class="subheading py-2">以下车辆信息格式错误</div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="errorHeader"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.fails"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                ></l-data-table>
              </div>
              <div class="mb-4" v-if="importErrorDialog.duplicates.length > 0">
                <div class="subheading py-2">以下车辆已在车辆列表中</div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="vehicleHeaders"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.duplicates"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                ></l-data-table>
              </div>
              <div v-if="importErrorDialog.vehicles.length > 0">
                <div class="py-2">
                  <div class="subheading">以下车辆信息正确，等待导入</div>
                  <div class="py-1" v-if="importErrorDialog.haveDuplicatePlate">
                    <span class="error--text caption">您导入的模板中含有重复的车牌，导入时将以重复数据的第一条为准</span>
                  </div>
                </div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="vehicleHeaders"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.vehicles"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                ></l-data-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="importVehicle(0)" color="grey" flat large>取消导入</v-btn>
              <v-btn :disabled="importErrorDialog.vehicles.length === 0"
                     @click="importVehicle(importErrorDialog.vehicles)"
                     color="error" flat large>仍然导入
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <v-flex class="text-xs-right pt-2">
      <v-btn :loading="submitLoading" @click="submit" class="mx-0" color="primary">提交</v-btn>
    </v-flex>
  </l-layout>
</template>

<script>
import XLSX from 'xlsx'
import LPlatePicker from '../../../components/LPlatePicker'
import LPassRuleList from '../../../components/LPassRuleList'
import SelectBeVisitDialog from './selectBeVisitDialog'
import PersonInfoCard from '../../../components/personInfoCard'
import SetPassRuleContent from '../../../components/SetPassRuleContent'
import {Reservation} from '../../../object'
import {ID_TYPE_TEXT, ID_TYPE_REVERSE} from '../../../consts/reservation'
import {passRule} from '@/mixins'

function VisitorVehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt,
  }
}
let errorMap = {
  '1': '电话格式有误',
  '2': '车牌号码有误'
}
export default {
  name: 'reservationForm',
  components: {SetPassRuleContent, PersonInfoCard, SelectBeVisitDialog, LPassRuleList, LPlatePicker},
  mixins: [passRule],
  props: {
    reservation: {
      type: Object,
      required: true,
    },
    authority: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reservationTips: '',
      isSelf: false,
      selfInfo: {
        total: '',
        perDay: ''
      },
      promptDefine: [
        {
          placeholder: '',
          disabled: false,
          key: 'ledPromptIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'audioPromptIn',
          label: '进场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'ledPromptOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'audioPromptOut',
          label: '出场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
      ],
      vehicleHeaders: [
        {text: '车辆号牌', value: 'plate', align: 'left', monospaced: '5.3em'},
        {text: '手机号码', value: 'ownerTel', align: 'right'},
        {text: '车主姓名', value: 'ownerName', align: 'right', placeholder: 'N/A'},
        {text: '所在单位', value: 'ownerOrg', align: 'right', placeholder: 'N/A'},
        {text: '证件类型', value: 'ownerIDType', align: 'right', placeholder: 'N/A', f: v => ID_TYPE_TEXT[v] || ''},
        {text: '证件号码', value: 'ownerIDNumber', align: 'right', placeholder: 'N/A'},
      ],
      errorHeader: [
        {text: '车辆号牌', value: 'plate', align: 'left', monospaced: '5.3em'},
        {text: '手机号码', value: 'ownerTel', align: 'right'},
        {text: '车主姓名', value: 'ownerName', align: 'right', placeholder: 'N/A'},
        {text: '所在单位', value: 'ownerOrg', align: 'right', placeholder: 'N/A'},
        {text: '证件类型', value: 'ownerIDType', align: 'right', placeholder: 'N/A', f: v => ID_TYPE_TEXT[v] || ''},
        {text: '证件号码', value: 'ownerIDNumber', align: 'right', placeholder: 'N/A'},
        {text: 'error', value: 'error', align: 'right', placeholder: 'N/A'},
      ],
      IDTypeReverseMap: ID_TYPE_REVERSE,
      IDTypeMap: ID_TYPE_TEXT,
      IDTypeItems: Object.keys(ID_TYPE_TEXT).map(key => ({text: ID_TYPE_TEXT[key], value: key})),
      beVisited: null,
      configDialog: {
        activate: false,
        item: {},
        loading: false,
        status: 'new',
        params: {},
      },
      templateHref: '',
      errorStatus: false,
      pageErrorMessage: '',
      vehicleFileProps: {
        activate: true,
        autoClose: true,
        title: '批量添加车辆',
      },
      vehicleFileRules: [
        v => !(!v || v.length === 0) || '必选',
        v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
      ],
      submitLoading: false,
      isAddingVehicle: false,
      selected: [],
      showAllPagination: {
        page: 1,
        rowsPerPage: 1000,
        sortBy: 'id',
      },
      importErrorDialog: {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      },
      addVehicleForm: {
        plate: '',
        ownerTel: '',
        ownerName: '',
        ownerOrg: '',
        ownerIDNumber: '',
        ownerIDType: '',
      },
      offsetTop: 0,
      mounted: 0,
      // passRuleDialog: {
      //   activate: false,
      //   status: 'new',
      //   item: {},
      //   index: 0,
      // },
    }
  },
  computed: {
    dark () {
      return this.$vuetify.dark
    },
    self () {
      return this.$store.state.login.self
    },
    isNew () {
      return true
    },
    isPersonal () {
      return this.$route.name === 'NewPersonalReservation'
    }
  },
  methods: {
    // openSetRuleDialog (status, item = {}, index) {
    //   this.passRuleDialog = {
    //     activate: true,
    //     status: status,
    //     item: item,
    //     index: status === 'new' ? this.reservation.rules.length : index,
    //   }
    // },
    // closeSetRuleDialog () {
    //   this.passRuleDialog = {
    //     activate: false,
    //     status: 'new',
    //     item: {},
    //     index: 0,
    //   }
    // },
    openAddVehicleForm () {
      this.isAddingVehicle = true
      // 临时提前验证，和通行关口统一
      this.$nextTick(() => {
        this.$refs.addVehicleForm.validate()
      })
    },
    saveBeVisited ({newItem, oldItem}) {
      this.reservation.owner = newItem
      this.configDialog.activate = false
    },
    async getVehicleFileTemplate () {
      try {
        let url = encodeURI('https://smaco2.uestc.edu.cn/passApi/files/预约车辆批量导入模版.xlsx')
        let isSupportDownload = 'download' in document.createElement('a')
        console.log('get url', url, isSupportDownload)
        let el = document.createElement('a')
        el.href = url
        el.target = '_blank'
        el.download = '预约车辆批量导入模版'
        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
      }
      catch (e) {
        this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
      }
    },
    resetImportDialog () {
      this.importErrorDialog = {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      }
    },
    importVehicle (vehicles) {
      if (vehicles) {
        this.reservation.vehicles.push(...vehicles)
        this.$L.alert('success', {message: `成功导入${vehicles.length}项`})
      }
      this.resetImportDialog()
    },
    checkVehicle (v) {
      if (!this.$reg.PLATE_PATTERN.test(v.plate.trim())) {
        return 2
      }
      if (!this.$reg.PHONE_ALL.test(v.ownerTel.trim())) {
        return 1
      }
      return 0
    },
    readExcel (files) {
      let f = files[0]
      if (!(f instanceof File)) return
      let reader = new FileReader()
      reader.onload = (event) => {
        try {
          let data = event.target.result
          let workbook = XLSX.read(data, {type: 'array'})
          let keys = Object.keys(workbook.Sheets)
          if (Object.keys(workbook.Sheets).length < 1) {
            throw Error('模板格式错误')
          }
          let sheet = workbook.Sheets[keys[0]]
          let ref = sheet['!ref']
          let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
          if (!group) {
            throw Error('模板格式错误')
          }
          let s = Number(group[1])
          let e = Number(group[2])

          if (e > this.authority.maxVehicleAmount + 1) {
            this.$L.alert('error', {
              title: '导入模板时发生错误',
              message: `给定文件条目超过最大单次预约车辆数，单次最多添加 ${this.authority.maxVehicleAmount} 辆车`,
            })
            return
          }

          let atters = ['A', 'B', 'C', 'D', 'E', 'F']
          let vehicles = []
          let fails = []
          let duplicates = []
          let haveDuplicatePlate = false

          for (let i = s + 1; i <= e; ++i) {
            let plate = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
            let phone = sheet[atters[1] + i] ? sheet[atters[1] + i].w : ''
            let org = sheet[atters[3] + i] ? sheet[atters[3] + i].w.trim() : ''
            let name = sheet[atters[2] + i] ? sheet[atters[2] + i].w.trim() : ''
            let IDType = sheet[atters[4] + i] ? sheet[atters[4] + i].w.trim() : ''
            let IDNumber = sheet[atters[5] + i] ? sheet[atters[5] + i].w.trim() : ''

            // Fixme: 需要检测去除所有左右空格（空白，换行，制表等）
            // console.log('/', plate, '/', phone, '/', org, '/', name, '/', IDType, '/', IDNumber, '/')
            if (!plate && !phone && !org && !name && IDType && !IDNumber) {
              continue
            }
            // 文字转key
            if (IDType) {
              console.log(IDType, this.IDTypeReverseMap[IDType])
            }
            IDType = this.IDTypeReverseMap[IDType] || ''
            let v = new VisitorVehicle(
              this.reservation.vehicles.length + vehicles.length,
              plate,
              phone,
              name,
              org,
              IDType,
              IDNumber,
            )
            let checkRes = this.checkVehicle(v)
            if (checkRes === 0) {
              if (this.reservation.vehicles.find(t => t.plate === v.plate)) {
                duplicates.push(v)
              }
              else {
                let tmp = vehicles.find(t => t.plate === v.plate)
                if (tmp) {
                  console.log('find duplicate', tmp, v)
                  haveDuplicatePlate = true
                }
                else {
                  vehicles.push(v)
                }
              }
            }
            else {
              v.error = errorMap[checkRes]
              fails.push(v)
            }
          }
          // 需要补全错误提示代码
          // this.importErrorDialog = {
          //   activate: true,
          //   vehicles: vehicles,
          //   fails: fails,
          //   duplicates: duplicates
          // }
          console.log('check import', fails, duplicates, vehicles)
          if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
            this.importVehicle(vehicles)
            // this.reservation.vehicles.push(...vehicles)
            // this.$store.commit('toggleSnackbar', {message: `成功导入${vehicles.length}项`})
          }
          else {
            this.importErrorDialog = {
              activate: true,
              vehicles: vehicles,
              fails: fails,
              duplicates: duplicates,
              haveDuplicatePlate: haveDuplicatePlate,
            }
          }
        }
        catch (e) {
          this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
        }
      }
      reader.readAsArrayBuffer(f)
    },
    async submit () {
      // console.log(this.reservation)
      if (this.isAddingVehicle) {
        if (this.$refs.addVehicleForm.validate()) {
          this.addVehicle()
        }
        else {
          return
        }
      }
      if (this.reservation.vehicles.length < 1 && !this.isSelf) {
        this.$L.alert('error', {title: '未选择预约车辆', message: '请填写预约车辆信息'})
        return
      }
      else if (this.reservation.rules.length < 1 && this.status !== 'addVehicle') {
        this.$L.alert('error', {title: '未选择通行规则', message: '请填写通行规则信息'})
        return
      }
      else if (!this.reservation.applicant && this.status !== 'addVehicle') {
        this.$L.alert('error', {title: '未选择受访人', message: '请添加受访人'})
        return
      }
      this.submitLoading = true
      if (this.isSelf) {
        if (this.selfInfo.perDay === '' && this.selfInfo.total === '') {
          this.$L.alert('error', {message: '请配置自助预约相关参数'})
          return
        }
      }
      //console.log(this.reservation)
      try {
        this.reservation.reservationTips = this.reservationTips
        if (this.isSelf) {
          this.reservation.selfSignInfo = this.selfInfo
        }
        let res = await this.$store.dispatch('reservation/submitReservation', {
          reservationGroup: this.reservation,
          type: this.type,
        })
        this.$L.alert('success', {message: (status === 'addVehicle') ? '添加成功' : '预约成功'})
        await this.$L.tab.close(this.$L.tab.current, false)
        if (this.status === 'addVehicle') {
          this.$router.push({
            name: 'ReservationGroupDetails',
            params: {id: this.reservation.id},
          })
        }
        else {
          let map = {
            [Reservation.ADMIN]: 'ReservationGroupList',
            [Reservation.ORG]: 'OrgReservation',
            [Reservation.PERSONAL]: 'PersonalReservation',
          }
          if (map[this.type]) {
            this.$router.push({
              name: map[this.type],
              params: {refresh: true},
            })
          } else {
            this.$router.push('/')
          }
        }
      }
      catch (e) {
        console.log(e)
        this.$L.alert('error', {title: '预约时发生错误', message: e.message, raw: e})
      }
      finally {
        this.submitLoading = false
      }
    },
    // async setPassRule (res, flag = true) {
    //   if (!flag || !res) {
    //     this.passRuleDialog.activate = false
    //     return
    //   }
    //   if (res.status === 'new' && res.newItem) {
    //     this.reservation.rules.push(res.newItem)
    //   }
    //   if (res.status === 'edit' && res.newItem) {
    //     let rules = this.reservation.rules
    //     let i = rules.indexOf(res.oldItem)
    //     if (i !== -1) {
    //       rules.splice(i, 1, res.newItem)
    //     }
    //   }
    //   this.closeSetRuleDialog()
    // },
    // async deleteRule (r, flag = true) {
    //   if (r) {
    //     let {res, close} = await this.$L.confirm({
    //       title: '确认删除',
    //       text: '确认删除此规则？',
    //     })
    //     if (res) {
    //       let rules = this.reservation.rules
    //       let i = rules.indexOf(r)
    //       // console.log(r, i)
    //       if (i !== -1) {
    //         rules.splice(i, 1)
    //       }
    //     }
    //     close()
    //   }
    // },
    async deleteVehicles (v, flag = true) {
      if (!v || !flag) {
        return
      }
      if (v instanceof Object) {
        let array = v instanceof Array ? v : [v]
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: '确认删除选中车辆？',
          subText: array.map(a => a.plate),
        })
        if (!res) {
          close()
          return
        }
        if (v instanceof Array) {
          let d = []
          this.reservation.vehicles.forEach((t, i) => {
            if (v.find(v_ => v_.plate === t.plate)) {
              d.push(i)
            }
          })
          d.sort((a, b) => a - b)
          for (let i = d.length - 1; i >= 0; --i) {
            this.reservation.vehicles.splice(d[i], 1)
          }
          this.selected = []
        }
        else if (v instanceof Object && v.plate) {
          let t = this.reservation.vehicles.find(v_ => v_.plate === v.plate)
          if (t) {
            let i = this.reservation.vehicles.indexOf(t)
            this.reservation.vehicles.splice(i, 1)
          }
        }
        close()
      }
      // console.log('delete vehicle success', this.selected)
    },
    addVehicle (flag = true) {
      if (!flag) {
        this.addVehicleForm = new VisitorVehicle()
        this.isAddingVehicle = false
        return
      }
      if (this.$refs.addVehicleForm.validate()) {
        // console.log('valid', this.addVehicleForm)
        let f = this.addVehicleForm
        // this.$nextTick(() => {
        this.reservation.vehicles.push(new VisitorVehicle(
          this.reservation.vehicles.length,
          f.plate,
          f.ownerTel,
          f.ownerName,
          f.ownerOrg,
          f.ownerIDType,
          f.ownerIDNumber,
        ))
        // })
        this.addVehicleForm = new VisitorVehicle()
        this.isAddingVehicle = false
      }
    },
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    go (path) {
      if (path) {
        this.$router.push(path)
      }
    },
    async getReservationInfo () {
      let {items} = await this.$store.dispatch('reservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: this.id}
      })
      if (items.length) {
        let item = items[0]
        this.$emit('updateReservation', item)
      }
      else {
        this.$L.alert('error', '未找到该高级预约')
      }
    }
  },
  async created () {
    if (this.isNew) {
      this.reservation.applicant = this.self
      this.reservation.owner = this.self
      let config = this.$store.state.reservation.globalConfig || {}
      this.reservation.audioPromptIn = config.audioPromptIn || ''
      this.reservation.ledPromptIn = config.ledPromptIn || ''
      this.reservation.audioPromptOut = config.audioPromptOut || ''
      this.reservation.ledPromptOut = config.ledPromptOut || ''
    }
    if (this.status === 'addVehicle') {
      this.getReservationInfo()
    }
    console.log('inDetails', this.reservation)
  },

}
</script>

<style scoped>

</style>
